import { Me } from '../../../@types/me';

const hasEnablement = (me: Me, shortName: string) =>
  me?.students?.some((student) =>
    student?.enablements?.some((enablement) => enablement.product.short_name === shortName)
  ) || false;

export default hasEnablement;
